var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.4,
    height: 12,
    viewBox: "0 0 7.4 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M7.4,1.41,5.992,0,0,6l5.992,6L7.4,10.59,2.826,6Z",
    fill: "#fe9362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackChevron);
export default __webpack_public_path__ + "static/media/backChevron.2578403ed20c487dc93adec2f273d383.svg";
export { ForwardRef as ReactComponent };